import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { updateProductListAdVariables, adminProductListAd_adminProductListAd, adminProductListAd, adminProductListAdVariables, adminProductListAd_adminProductListAd_product, ProductListAdType } from '@api/graphql/types';
import { ApolloQueryResult } from 'apollo-client';
import Notification from 'components/Notification';
import { Loading } from '@components/Loading';
import ProductListAdForm from "../components/ProductListAdForm";
import { ProductValueLabel } from "../components/ProductInput";
import { removeProp } from "@root/utils/Object";

type Props = InjectedIntlProps & RouteComponentProps<{ id: string }>;

interface State {
    formData: updateProductListAdVariables | null;
    selectedProduct?: ProductValueLabel;
}

class ProductListAdEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: null,
        };
    }

    public componentDidMount() {
        GraphQLClient.query<adminProductListAd, adminProductListAdVariables>({
            query: Queries.adminProductListAd,
            variables: { id: this.props.match.params.id },
        }).then((response: ApolloQueryResult<adminProductListAd>) => {
            if (response.data && response.data.adminProductListAd) {
                this.setState({
                    formData: this.convertFormDataResponse(response.data.adminProductListAd),
                    selectedProduct: this.convertProductResponse(response.data.adminProductListAd.product),
                });
            }
        }).catch(() => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    /**
     * Convert back-end response from adminProductListAd_adminProductListAd to updateProductListAdVariables to initialize data
     */
    private convertFormDataResponse = (response: adminProductListAd_adminProductListAd): updateProductListAdVariables => {
        const newFormData: adminProductListAd_adminProductListAd = { ...response };

        return {
            ...newFormData,
            product_id: response.product ? response.product.id : null,
            urls: response.urls || [],
        };
    }

    /**
     * Shorter way of converting the product response into ProductValueLabel
     */
    private convertProductResponse = (product: adminProductListAd_adminProductListAd_product | null): ProductValueLabel | undefined => {
        if (product) {
            return {
                value: product.id,
                label: product.name,
            };
        }
        return undefined;
    }


    private onFormChange = (formData: updateProductListAdVariables) => {
        this.setState({ formData });
    }

    private onProductChange = (selectedProduct: ProductValueLabel) => {
        this.setState({
            formData: this.state.formData ? {
                ...this.state.formData,
                product_id: selectedProduct.value,
            } : null,
            selectedProduct,
        });
    }

    private onSubmit = (formData: updateProductListAdVariables) => {
        removeProp(formData, '__typename');
        const variables: any = { ...formData, product: undefined };
        variables.id = this.props.match.params.id;

        return GraphQLClient.mutate({
            mutation: Mutations.updateProductListAd,
            variables: this.cleanUnusedVariables(variables),
        });
    }

    private cleanUnusedVariables = (variables: updateProductListAdVariables) => {
        if (variables.type === ProductListAdType.BANNER) {
            return {
                ...variables,
                product_id: null,
            };
        }
        return {
            ...variables,
            banner_url: null,
            image_url_desktop: null,
            image_url_mobile: null,
        };
    }

    public render() {
        if (!this.state.formData) {
            return <Loading />;
        }

        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.productListAd.edit.title' })}</h5>
                        </div>
                        <div className="ibox-content">
                            <ProductListAdForm
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                                onProductChange={this.onProductChange}
                                selectedProduct={this.state.selectedProduct}
                                onFormChange={this.onFormChange}
                                redirectFunction={() => undefined}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(ProductListAdEdit);


// WEBPACK FOOTER //
// ./src/modules/ProductListAd/pages/ProductListAdEdit.tsx